export default __webpack_public_path__ + "static/media/solution-une.6640fee4.svg";